module.exports = __webpack_public_path__ + "9d5e2326d56eb7353b00ab83d5e25a2e.png";